import { TAuthenticationType, IUpdateExtensionRequest } from 'src/api/extensions';

export interface IAuthFormValues {
  username?: string;
  password?: string;
  access_token?: string;
  contents?: string;
}

type TAuthenticationPayload = IUpdateExtensionRequest['authentication'];

/**
 * Builds the authentication payload for the credential type an addon accepts.
 *
 * Returns null when the type is unknown or the fields it needs are empty, so the
 * caller can tell the user what is missing instead of submitting nothing.
 */
export const buildAuthenticationPayload = (
  authType: TAuthenticationType | undefined,
  { username, password, access_token, contents }: IAuthFormValues,
): TAuthenticationPayload | null => {
  if (authType === 'BASIC' && username && password) {
    return { type: 'BASIC', credentials: { username, password } };
  }

  if (authType === 'TOKEN' && access_token) {
    return { type: 'TOKEN', credentials: { access_token } };
  }

  if (authType === 'CERTIFICATE' && contents) {
    return { type: 'CERTIFICATE', credentials: { contents } };
  }

  return null;
};
